import { render, staticRenderFns } from "./TransactionalProfileIntro.vue?vue&type=template&id=219294d6&scoped=true"
import script from "./TransactionalProfileIntro.vue?vue&type=script&lang=js"
export * from "./TransactionalProfileIntro.vue?vue&type=script&lang=js"
import style0 from "./TransactionalProfileIntro.vue?vue&type=style&index=0&id=219294d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219294d6",
  null
  
)

export default component.exports